import { dbsKeys } from "data/dbsKeys";
import { generateId, readCollection, writeCollection } from "data/dbsStorage";

const EMPTY = [];

export const paymentsRepo = {
  list() {
    return readCollection(dbsKeys.payments, EMPTY);
  },

  create(payment) {
    const items = paymentsRepo.list();
    const next = {
      id: generateId("pay"),
      createdAt: new Date().toISOString(),
      status: "completed",
      ...payment,
    };
    writeCollection(dbsKeys.payments, [next, ...items]);
    return next;
  },
};
